var React = require('react');

function GreenCheck (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"16","r":"16","fill":"#55FF8A","fillOpacity":".15","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24.414 10.586a2 2 0 0 1 0 2.828l-10 10a2 2 0 0 1-2.828 0l-4-4a2 2 0 1 1 2.828-2.828L13 19.172l8.586-8.586a2 2 0 0 1 2.828 0z","fill":"#55FF8A","key":1})]);
}

GreenCheck.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = GreenCheck;

GreenCheck.default = GreenCheck;
